import * as yup from "yup";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
export const useDemoFormValidationSchema = () => {
    const intl = useIntl();
    return yup.object({
        email: yup
            .string()
            .email(intl.formatMessage(messages.demoEmailError))
            .required(intl.formatMessage(messages.demoEmailRequired)),
        name: yup.string().required(intl.formatMessage(messages.demoNameRequired)),
        communityName: yup.string().required(intl.formatMessage(messages.demoCommunityNameRequired)),
    });
};
export const DemoFormInitialValues = {
    email: "",
    name: "",
    communityName: "",
};
export const useDemoFormFields = () => {
    const intl = useIntl();
    return [
        {
            id: "email",
            label: intl.formatMessage(messages.demoEmailLabel),
            placeholder: intl.formatMessage(messages.demoEmailPlaceholder),
            required: true,
        },
        {
            id: "name",
            label: intl.formatMessage(messages.demoNameLabel),
            placeholder: intl.formatMessage(messages.demoNamePlaceholder),
            required: true,
        },
        {
            id: "communityName",
            label: intl.formatMessage(messages.demoCommunityNameLabel),
            placeholder: intl.formatMessage(messages.demoCommunityNamePlaceholder),
            required: true,
        },
    ];
};
